module.exports = __webpack_public_path__ + "static/media/search_blue_small.1485757a.png";